<script lang="ts">
    import type { ColorVariation } from '@shared/types/types';

    interface Props {
        colors?: ColorVariation[];
    }

    let { colors }: Props = $props();

    const totalNumberOfColors = $derived(colors?.length || 0);
    const shown = $derived(colors?.slice(0, 3));
    const additional = $derived(colors?.slice(3));
</script>

{#if colors && totalNumberOfColors > 1}
    <ul class="reptile-color-thumbs">
        {#each shown as [_, color], i (color.name)}
            <li
                style:background-color={color.hexCode ? `#${color.hexCode}` : undefined}
                style:z-index={colors.length - i}
                class={['reptile-color-thumbs__thumb', !color.hexCode ? color.baseColor || 'weiss' : '']}
            >
                <span class="oc-visually-hidden">{color.name}</span>
            </li>
        {/each}
        {#if additional?.length}
            <li class="reptile-color-thumbs__additional-colors">
                <span class="oc-visually-hidden">weitere Farben: </span>+{additional.length}
            </li>
        {/if}
    </ul>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-color-thumbs {
        display: flex;
        align-items: center;
        /*                                                                                                                                                       */
        isolation: isolate;

        &__thumb {
            height: tokens.$oc-base-dimension-absolute-16;
            width: tokens.$oc-base-dimension-absolute-16;
            /*                                                                                                                                                                       */
            /*                                                                                                                                                                                                                                                                                               */
            outline: tokens.$oc-semantic-border-width-100 solid tokens.$oc-base-color-gray-150;
            border-radius: 50%;

            @include mixins.base-color-swatch;

            &:not(:first-child) {
                /*                                                                    */
                margin-left: -5px;
            }
        }

        &__additional-colors {
            font-size: tokens.$oc-base-font-size-75;
            margin-left: tokens.$oc-semantic-spacing-absolute-25;
        }
    }
</style>
